import { Expose } from 'class-transformer';
import { BaseModel } from '../../../common-sdk';

export enum NavResourceType {
  HARDWARE = 'HARDWARE', // Sprzęt
  EMPLOYEE = 'EMPLOYEE', // Pracownik
}

export enum NavResourceUnit {
  MG = 'MG', // Tona
  UNIT = 'UNIT', // Szt.
  SERVICE = 'SERVICE', // Usługa
}

export enum NavResourceAccountingGroup {
  CONSULTANCY = 'CONSULTANCY', // Doradztwo
  COMMODITY = 'COMMODITY', // Towar
  SERVICES = 'SERVICES', // Inne usługi
  RSI = 'RSI',
}

export class NavResourceModel extends BaseModel {
  @Expose()
  code: string | undefined;

  @Expose()
  name: string | undefined;

  @Expose()
  type: NavResourceType | undefined;

  @Expose()
  unit: NavResourceUnit | undefined;

  @Expose()
  price: number | undefined; // in PLN gr

  @Expose()
  accountingGroup: NavResourceAccountingGroup | undefined;
}
